
<div class="shape-selector">
    <div #shapeSelector class="canvas"></div>
</div>
